import React, { useState, useEffect } from 'react';

import { Redirect, Route, Switch/*, useLocation*/ } from 'react-router-dom';
//import {useLocation } from 'react-router-dom';

import './App.css';

//import Login from './components/Login/Login';

import useToken from './UseToken';

import Pagina from './components/Pagina/Pagina';
//import AppForm from './components/Pagina/Forms/AppForm';



/*import politicaPrivacidade from "./components/Pagina/Conteudo/politicaPrivacidade"; */
//import termosCondicoes from "./components/Pagina/Conteudo/termosCondicoes";

import Cookies from "./components/Pagina/Cookies/Cookies";

import GoTopButton from './components/Pagina/GoTopButton/GoTopButton';

import Content from './components/Pagina/Content/Content';

import Store from './components/Pagina/Store/Content';

import Forfaits from './components/Pagina/Forfait/Forfait';
import Equipamentos from './components/Pagina/Equipamento/Equipamento';
// import Vouchers from './components/Pagina/Voucher/Voucher';
import Packs from './components/Pagina/Pack/Pack';
import Atividades from './components/Pagina/Atividade/Atividade';
import Cart from './components/Pagina/Cart/Cart';
import PaymentNotificationPage from './components/Pagina/Store/PaymentNotificationPage';
import PaymentNotificationPageApp from './components/Pagina/Store/PaymentNotificationPageApp';
import Aula from './components/Pagina/Aula/Aula';
import Aula_Store from './components/Pagina/Aula_Store/Aula_Store';

import Reservas from './components/Pagina/GoldenRock/Reserva';
import Service from './components/Pagina/GoldenRock/Service';
import GoldenRock_Cart from './components/Pagina/GoldenRock/Cart';

import Entrance from './components/Pagina/GoldenRock/Entrance';

//import MapaPistas from './components/Pagina/MapaPistas/mapaPistas';

//import LiveCam from './components/Pagina/Navbar_Extra/Livecam';
//import Accesses from './components/Pagina/Navbar_Extra/Accesses';

//import Contact from "./components/Pagina/Forms/ContactForm";
import RegistClient from "./components/Pagina/Forms/RegisterClient";
import RecoveryClient from "./components/Pagina/Forms/RecoveryClient";

import PerfilClient from "./components/Pagina/Cliente/Perfil";
import OrdersClient from "./components/Pagina/Cliente/Encomendas";

import Loader from './loader'

//import Navbar from './components/Pagina/Navbar/Navbar';

//import CookieConsent from "react-cookie-consent";


import * as Hosts from './Hosts';

import "../src/components/Pagina/Pagina.css";

import {
  repo_favicon_link,
  set_language
} from './Utils';
import GenericStore from './components/Pagina/GenericStore/GenericStore';
import ProdByCategory from './components/Pagina/GenericStore/ProdByCategory';
import ProdByCategoryDesk from './components/Pagina/GenericStore/ProdByCategoryDesk';
import ProdByIdDesk from './components/Pagina/GoldenRock/ServiceDesk';
import CartDesk from './components/Pagina/GoldenRock/CartDesk';
import useContextProvider from './components/Pagina/GenericStore/Providers/ContextProvider';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

import VisitaVirtual from './components/Pagina/GoldenRock/VisitaVirtual';

//if (process.env.REACT_APP_MODE === 'production') console.log = function () { };

function App() {

  const { on_init, set_var_timer_countdown, get_lista_carrinho, get_is_logged } = useContextProvider()
  const history = useHistory();

  //const { pathname } = useLocation();

  const { setToken } = useToken();

  const [, set_is_loading] = useState(true)



  const handleFavIcon = () => {

    function getFaviconEl() {
      return document.getElementById("favicon");
    }
    const favicon = getFaviconEl(); // Accessing favicon element
    //console.log('FavICON', repo_favicon_link("favicon.ico"))
    //console.log('FavICON get', document.getElementById("favicon"))
    favicon.href = repo_favicon_link("favicon.ico");
    //favicon.href = "favicon.ico";
  };

  // 
  //document.title = `${document.title}-Scientia`
  handleFavIcon()

  //const page_location = useLocation().pathname.split('/').pop();

  //const [lang, set_lang] = useState(localStorage.getItem('lang'));

  //const menus = [];
  //const { sideBarData, setSideBarData, getSidebar } = useSidebar();


  //const [menus, setMenus] = useState([])

  //const [isloading, setLoading] = useState(true);

  //const [isloading, setLoading] = useState(true);

  //LOADER TIMEOUT
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);

  useEffect(() => {
    if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null) {
      set_language('pt')
    }

    //setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })
    setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })

    const timer = setTimeout(() => {
      setIsLoading(false);
      //setCount('Timeout called!');
    }, 500);

    return () => clearTimeout(timer);

    /*    setTimeout(() => {
        setIsLoading(false);
      }, 500);  */
  }, [setToken])


  /*useEffect(() => {
    setToken({ "token_site": Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN })
    //console.log('token_site', Hosts.SITES.SIMWEBSITE.ACCESS_TOKEN)

    /* setTimeout(() => {
    setLoading(false)
    /* })

  }, [])*/




  useEffect(() => {

    const aux_func = async () => {
      // await  useContextProvider().on_init(set_is_loading)
      await on_init(set_is_loading, history.action, get_lista_carrinho)

      if (get_is_logged() === true) {
        await set_var_timer_countdown()

      }

      console.log('############')

    }

    (async () => {


      await aux_func()
      // window.addEventListener("focus", async() => await on_init(set_is_loading));
      //console.error('history.action', history.action)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])




  return isLoading ?
      <main>
        <Loader />
      </main>
    :
      <>
        <Cookies />
        <GoTopButton />

        <>
          {/* <Navbar /> */}
          {/*  <Pagina /> */}
          <Switch >

            <Route path='/' exact component={Pagina} />
            {/*<Route path="/app_form" exact component={AppForm} />*/}

            {/*<Route path={"/terms_conditions"} exact component={termosCondicoes} />
            <Route path={"/privacy_policy"} exact component={termosCondicoes} />
            <Route path={"/contact"} exact component={Contact} />*/}

            {/*<Route path={"/mapa_pistas"} exact component={MapaPistas} />
            <Route path={"/livecam"} exact component={LiveCam} />
          <Route path={"/accesses"} exact component={Accesses} />*/}

            <Route path={"/pag/:pag_id"} component={Content} exact={true} />

            <Route path={"/article/:article_id"} component={Content} exact={true} />
            <Route path={"/press/:press_id"} component={Content} exact={true} />
            <Route path={"/gallery/:gallery_id"} component={Content} exact={true} />
            <Route path={"/store/product/:product_id"} component={Store} exact={true} />

            <Route path={"/desk"} component={ProdByCategoryDesk} exact={true} />
            <Route path={"/desk/cart"} component={CartDesk} exact={true} />
            <Route path={"/desk/service/:product_id"} component={ProdByIdDesk} exact={true} />
            <Route path={"/reservation/service"} component={GenericStore} exact={true} />

            <Route path={"/store/forfaits"} component={Forfaits} exact={true} />
            <Route path={"/store/equipments"} component={Equipamentos} exact={true} />
            {/*
            <Route path={"/store/vouchers"} component={Vouchers} exact={true} />
            */}
            <Route path={"/store/packs"} component={Packs} exact={true} />
            <Route path={"/store/activities"} component={Atividades} exact={true} />
            <Route path={"/store/aulas"} component={Aula_Store} exact={true} />


            <Route path={"/reservation/service/:id"} component={Service} exact={true} />
            <Route path={"/reservation/service"} component={Reservas} exact={true} />

            <Route path={"/store/:category"} component={ProdByCategory} exact={true} />
            <Route path={"/store"} component={GenericStore} exact={true} />

            <Route path={"/reservation/entrance"} component={Entrance} exact={true} />

            <Route path={"/reservation/cart"} component={GoldenRock_Cart} exact={true} />

            <Route path={"/store/cart"} component={Cart} exact={true} />
            <Route path={"/store/payment/notification/status/:key/:state"} component={PaymentNotificationPage} exact={true} />
            <Route path={"/app/payment/notification/status/:key/:state"} component={PaymentNotificationPageApp} exact={true} />

            <Route path={"/agendar/aula/:order"} component={Aula} exact={true} />

            <Route path={"/client/perfil"} component={PerfilClient} exact={true} />
            <Route path={"/client/order"} component={OrdersClient} exact={true} />

            <Route path={"/regist/client"} component={RegistClient} exact={true} />
            <Route path={"/regist/client/recovery/:hash"} component={RecoveryClient} exact={true} />

            <Route path={"/preview/:preview_id"} component={Content} exact={true} />

            {/*   <Route exact path={Hosts.WEB_SITE_URI + "contacts"} component={Contact} /> */}

            {/*  <Route path={Hosts.WEB_SITE_URI + "terms_conditions"} exact component={termosCondicoes} />
            <Route path={Hosts.WEB_SITE_URI + "privacy_policy"} exact component={politicaPrivacidade} /> */}
            <Route path={"/visita-virtual"} component={VisitaVirtual} exact={true} />
            <Route path={"/:slug"} component={Content} exact={true} />

            <Redirect to="/" />


          </Switch >
        </>
      </>
}

export default App;

